<template>
  <div class="flex items-center">
    <button
      class="mr-2"
      :disabled="selectedPage === 1"
      @click="onClickFirstPage"
    >
      <svg
        :class="selectedPage === 1 ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full transform"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.14142 12.8486C6.33943 13.0466 6.43843 13.1456 6.5526 13.1827C6.65302 13.2154 6.76119 13.2154 6.86161 13.1827C6.97578 13.1456 7.07478 13.0466 7.27279 12.8486L7.55563 12.5658C7.75364 12.3678 7.85265 12.2688 7.88974 12.1546C7.92237 12.0542 7.92237 11.946 7.88974 11.8456C7.85265 11.7314 7.75364 11.6324 7.55563 11.4344L3.39411 7.27289C3.1961 7.07488 3.0971 6.97587 3.06001 6.86171C3.02738 6.76129 3.02738 6.65311 3.06001 6.55269C3.0971 6.43853 3.1961 6.33952 3.39411 6.14151L7.55563 1.97999C7.75364 1.78198 7.85265 1.68298 7.88974 1.56882C7.92237 1.46839 7.92237 1.36022 7.88974 1.2598C7.85265 1.14563 7.75364 1.04663 7.55563 0.848622L7.27279 0.565779C7.07478 0.367771 6.97578 0.268767 6.86161 0.231673C6.76119 0.199044 6.65302 0.199044 6.5526 0.231673C6.43843 0.268767 6.33943 0.367771 6.14142 0.565778L0.565685 6.14152C0.367677 6.33952 0.268672 6.43853 0.231578 6.55269C0.198949 6.65311 0.198949 6.76129 0.231578 6.86171C0.268672 6.97587 0.367676 7.07488 0.565685 7.27289L6.14142 12.8486Z"
          fill="#6C7C9D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4344 0.565685C13.6324 0.367677 13.7314 0.268673 13.8456 0.231578C13.946 0.198949 14.0542 0.198949 14.1546 0.231578C14.2687 0.268673 14.3678 0.367677 14.5658 0.565685L14.8486 0.848528C15.0466 1.04654 15.1456 1.14554 15.1827 1.2597C15.2153 1.36013 15.2153 1.4683 15.1827 1.56872C15.1456 1.68289 15.0466 1.78189 14.8486 1.9799L10.6871 6.14142C10.4891 6.33943 10.3901 6.43843 10.353 6.5526C10.3203 6.65302 10.3203 6.76119 10.353 6.86161C10.3901 6.97578 10.4891 7.07478 10.6871 7.27279L14.8486 11.4343C15.0466 11.6323 15.1456 11.7313 15.1827 11.8455C15.2153 11.9459 15.2153 12.0541 15.1827 12.1545C15.1456 12.2687 15.0466 12.3677 14.8486 12.5657L14.5658 12.8485C14.3678 13.0465 14.2687 13.1455 14.1546 13.1826C14.0542 13.2153 13.946 13.2153 13.8456 13.1826C13.7314 13.1455 13.6324 13.0465 13.4344 12.8485L7.85865 7.27279C7.66065 7.07478 7.56164 6.97578 7.52455 6.86161C7.49192 6.76119 7.49192 6.65302 7.52455 6.5526C7.56164 6.43843 7.66065 6.33943 7.85865 6.14142L13.4344 0.565685Z"
          fill="#6C7C9D"
        />
      </svg>
    </button>
    <button
      :disabled="selectedPage === 1"
      @click="onClickBack"
    >
      <svg
        :class="selectedPage === 1 ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full transform"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7274 5.85853C13.9254 5.66052 14.0244 5.56152 14.1385 5.52443C14.239 5.4918 14.3471 5.4918 14.4476 5.52443C14.5617 5.56152 14.6607 5.66052 14.8587 5.85853L15.1416 6.14137C15.3396 6.33938 15.4386 6.43839 15.4757 6.55255C15.5083 6.65297 15.5083 6.76115 15.4757 6.86157C15.4386 6.97573 15.3396 7.07474 15.1416 7.27275L10.98 11.4343C10.782 11.6323 10.683 11.7313 10.6459 11.8454C10.6133 11.9459 10.6133 12.054 10.6459 12.1545C10.683 12.2686 10.782 12.3676 10.9801 12.5656L15.1416 16.7272C15.3396 16.9252 15.4386 17.0242 15.4757 17.1383C15.5083 17.2388 15.5083 17.3469 15.4757 17.4474C15.4386 17.5615 15.3396 17.6605 15.1416 17.8585L14.8587 18.1414C14.6607 18.3394 14.5617 18.4384 14.4476 18.4755C14.3471 18.5081 14.239 18.5081 14.1385 18.4755C14.0244 18.4384 13.9254 18.3394 13.7274 18.1414L8.15162 12.5656C7.95361 12.3676 7.85461 12.2686 7.81752 12.1545C7.78489 12.054 7.78489 11.9459 7.81752 11.8454C7.85461 11.7313 7.95361 11.6323 8.15162 11.4343L13.7274 5.85853Z"
          fill="#6C7C9D"
        />
      </svg>
    </button>
    <span
      v-for="page in shownPages"
      :key="'page_' + page"
      class="flex h-8 w-8 cursor-pointer items-center justify-center rounded"
      :class="
        page === selectedPage
          ? 'selected-tab-text text-selected-tab-text border border-yellow-500 bg-sun-50'
          : 'text-info-bold-text font-normal'
      "
      @click="onClickPage(page)"
    >
      {{ page }}
    </span>
    <button
      :disabled="selectedPage === totalPages"
      class="mr-2"
      @click="onClickNext"
    >
      <svg
        :class="selectedPage === totalPages ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full rotate-180 transform"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7274 5.85853C13.9254 5.66052 14.0244 5.56152 14.1385 5.52443C14.239 5.4918 14.3471 5.4918 14.4476 5.52443C14.5617 5.56152 14.6607 5.66052 14.8587 5.85853L15.1416 6.14137C15.3396 6.33938 15.4386 6.43839 15.4757 6.55255C15.5083 6.65297 15.5083 6.76115 15.4757 6.86157C15.4386 6.97573 15.3396 7.07474 15.1416 7.27275L10.98 11.4343C10.782 11.6323 10.683 11.7313 10.6459 11.8454C10.6133 11.9459 10.6133 12.054 10.6459 12.1545C10.683 12.2686 10.782 12.3676 10.9801 12.5656L15.1416 16.7272C15.3396 16.9252 15.4386 17.0242 15.4757 17.1383C15.5083 17.2388 15.5083 17.3469 15.4757 17.4474C15.4386 17.5615 15.3396 17.6605 15.1416 17.8585L14.8587 18.1414C14.6607 18.3394 14.5617 18.4384 14.4476 18.4755C14.3471 18.5081 14.239 18.5081 14.1385 18.4755C14.0244 18.4384 13.9254 18.3394 13.7274 18.1414L8.15162 12.5656C7.95361 12.3676 7.85461 12.2686 7.81752 12.1545C7.78489 12.054 7.78489 11.9459 7.81752 11.8454C7.85461 11.7313 7.95361 11.6323 8.15162 11.4343L13.7274 5.85853Z"
          fill="#6C7C9D"
        />
      </svg>
    </button>
    <button
      class="mr-2"
      :disabled="selectedPage === totalPages"
      @click="onClickLastPage"
    >
      <svg
        :class="selectedPage === totalPages ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full rotate-180 transform"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.14142 12.8486C6.33943 13.0466 6.43843 13.1456 6.5526 13.1827C6.65302 13.2154 6.76119 13.2154 6.86161 13.1827C6.97578 13.1456 7.07478 13.0466 7.27279 12.8486L7.55563 12.5658C7.75364 12.3678 7.85265 12.2688 7.88974 12.1546C7.92237 12.0542 7.92237 11.946 7.88974 11.8456C7.85265 11.7314 7.75364 11.6324 7.55563 11.4344L3.39411 7.27289C3.1961 7.07488 3.0971 6.97587 3.06001 6.86171C3.02738 6.76129 3.02738 6.65311 3.06001 6.55269C3.0971 6.43853 3.1961 6.33952 3.39411 6.14151L7.55563 1.97999C7.75364 1.78198 7.85265 1.68298 7.88974 1.56882C7.92237 1.46839 7.92237 1.36022 7.88974 1.2598C7.85265 1.14563 7.75364 1.04663 7.55563 0.848622L7.27279 0.565779C7.07478 0.367771 6.97578 0.268767 6.86161 0.231673C6.76119 0.199044 6.65302 0.199044 6.5526 0.231673C6.43843 0.268767 6.33943 0.367771 6.14142 0.565778L0.565685 6.14152C0.367677 6.33952 0.268672 6.43853 0.231578 6.55269C0.198949 6.65311 0.198949 6.76129 0.231578 6.86171C0.268672 6.97587 0.367676 7.07488 0.565685 7.27289L6.14142 12.8486Z"
          fill="#6C7C9D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4344 0.565685C13.6324 0.367677 13.7314 0.268673 13.8456 0.231578C13.946 0.198949 14.0542 0.198949 14.1546 0.231578C14.2687 0.268673 14.3678 0.367677 14.5658 0.565685L14.8486 0.848528C15.0466 1.04654 15.1456 1.14554 15.1827 1.2597C15.2153 1.36013 15.2153 1.4683 15.1827 1.56872C15.1456 1.68289 15.0466 1.78189 14.8486 1.9799L10.6871 6.14142C10.4891 6.33943 10.3901 6.43843 10.353 6.5526C10.3203 6.65302 10.3203 6.76119 10.353 6.86161C10.3901 6.97578 10.4891 7.07478 10.6871 7.27279L14.8486 11.4343C15.0466 11.6323 15.1456 11.7313 15.1827 11.8455C15.2153 11.9459 15.2153 12.0541 15.1827 12.1545C15.1456 12.2687 15.0466 12.3677 14.8486 12.5657L14.5658 12.8485C14.3678 13.0465 14.2687 13.1455 14.1546 13.1826C14.0542 13.2153 13.946 13.2153 13.8456 13.1826C13.7314 13.1455 13.6324 13.0465 13.4344 12.8485L7.85865 7.27279C7.66065 7.07478 7.56164 6.97578 7.52455 6.86161C7.49192 6.76119 7.49192 6.65302 7.52455 6.5526C7.56164 6.43843 7.66065 6.33943 7.85865 6.14142L13.4344 0.565685Z"
          fill="#6C7C9D"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    selectedPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    pagesAround: {
      type: Number,
      default: 1,
    },
    equivalent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const shownPages = computed(() => {
      let low = Math.max(1, props.selectedPage - props.pagesAround);
      let high = Math.min(
        props.selectedPage + props.pagesAround,
        props.totalPages
      );

      // You need the possibility to always keep five options, with a page around on 2 would work for example,
      // when 3 is selected you will have: 1 2 3 4 5 (two on the left, two on the right).
      // In this same case, you have a problem when the selected page is 2 or 1. Because if the page around is 2,
      // then for 2 you would have 1 2 3 3 4 (here the condition that 5 are needed is not fulfilled.

      // Requirements:
      // - You need to use the prop equivalent as true.

      if (props.equivalent) {
        if (props.selectedPage === 1 || props.selectedPage === 2) {
          if (props.totalPages > 5) {
            low = 1;
            high = 5;
          }
        }
      }

      const numbers = [];

      for (let i = low; i <= high; i++) {
        numbers.push(i);
      }

      return numbers;
    });

    const onClickPage = (newPage) => {
      emit('selectPage', newPage);
    };

    const onClickNext = () => {
      if (props.selectedPage + 1 > props.totalPages) {
        return;
      }
      emit('selectPage', props.selectedPage + 1);
    };

    const onClickBack = () => {
      if (props.selectedPage - 1 <= 0) {
        return;
      }
      emit('selectPage', props.selectedPage - 1);
    };

    const onClickFirstPage = () => {
      emit('selectPage', 1);
    };

    const onClickLastPage = () => {
      emit('selectPage', props.totalPages);
    };

    return {
      shownPages,
      onClickPage,
      onClickNext,
      onClickBack,
      onClickFirstPage,
      onClickLastPage,
    };
  },
};
</script>
